import { format } from "date-fns";
export const formatGroupDate = timestamp => format(timestamp, "dd MMM yyyy");